import type { LevelId } from '@/state/types';
import { levelIdKey } from './LevelController';
import styles from './LevelCrash.module.css';

export interface LevelCrashProps {
  id: LevelId;
}

export function LevelCrash({ id }: LevelCrashProps) {
  return (
    <div
      role="alert"
      className={styles.crash}
      data-testid="level-crash"
      data-level={levelIdKey(id)}
    >
      <h2 className={styles.title}>LEVEL FAULT</h2>
      <p className={styles.line}>That one misbehaved.</p>
      <p className={styles.line}>Reload. I'll pretend it didn't happen.</p>
    </div>
  );
}
